import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventPreviewModalComponent } from '../../_admin/events/components/event-preview-modal/event-preview-modal.component';
import { EventDTO } from '../../_admin/events/models/EventDTO';
import { EventService } from '../../_admin/events/service/event.service';
import { getBlobUrl } from '../../shared/_helpers/blob-url.helper';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-events-widget',
  templateUrl: './events-widget.component.html',
  styleUrls: ['./events-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EventsWidgetComponent {
  userEvents: EventDTO[] | undefined = [];
  @Output() isLoading = new EventEmitter<boolean>(true);

  constructor(
    private userEventService: EventService,
    private modalService: BsModalService
  ) {
    this.isLoading.emit(true);
    this.userEventService.GetLastsEvents().subscribe((data) => {
      this.userEvents = data;
      this.isLoading.emit(false);
    });
  }

  PreviewEvent(userEvent: EventDTO) {
    const initialState = {
      name: userEvent.name,
      description: userEvent.description,
      startDate: userEvent.startDate,
      endDate: userEvent.endDate,
      image: getBlobUrl(environment.containerUserEventsName, userEvent.image),
    };
    this.modalService.show(EventPreviewModalComponent, {
      class: 'modal-xl modal-dialog-centered',
      initialState: initialState,
    });
  }

  checkDate(startDate: Date, endDate: Date) {
    return !(
      new Date(startDate).getHours() === new Date(endDate).getHours() &&
      new Date(startDate).getMinutes() === new Date(endDate).getMinutes()
    );
  }
}
